/* eslint-disable react-hooks/exhaustive-deps */

import { useAppContext } from '@contexts/app';
import { useQueryParams } from '@hooks/queryParams';
import { getSlug, removeSlug } from '@hooks/slug/helpers';
import { useGetAdmin } from '@services/panel/admins/get';
import { useGetUser } from '@services/users/get';
import { getUserData } from '@utils/getUserData';
import { localStore } from '@utils/localStore';
import { modelUserData } from '@utils/userData';
import { useEffect, useState } from 'react';

export const useAuth = () => {
  const {
    params: { auth },
    setParams,
  } = useQueryParams();

  const { isLogged, setData } = useAppContext();

  const localAdmin = getUserData('admin');
  const localUser = getUserData('user');
  const [cachedAuth, setCachedAuth] = useState('');
  const slug = getSlug();

  const admin = useGetAdmin(localAdmin?.id);
  const user = useGetUser(localUser?.id);

  useEffect(() => {
    if (!admin.data || admin.isLoading) return;
    const { data } = admin.data;

    setData((prev) => ({
      ...prev,
      admin: {
        data,
        isLogged: true,
      },
    }));
  }, [setData, admin.data, admin.isLoading]);

  useEffect(() => {
    if (!user.data || user.isLoading) return;
    const { data, onDeckAlerts, hotSeatAlerts } = user.data;

    setData((prev) => ({
      ...prev,
      ...modelUserData(data),
      isLogged: true,
      isDropdownEnabled: data.role !== 'foreman',
      onDeckError: onDeckAlerts,
      hotSeatError: hotSeatAlerts,
    }));
  }, [setData, user.data, user.isLoading]);

  useEffect(() => {
    if (!cachedAuth) return;
    localStore.setItem('app-user', cachedAuth);
    setCachedAuth('');
  }, [cachedAuth]);

  useEffect(() => {
    if (!auth) return;
    setCachedAuth(auth);
    setParams({ auth: '' }, { disableSaveFilters: true });
  }, [auth]);

  useEffect(() => {
    if (slug && !localStore.getItem('app-user') && !auth) removeSlug();
  }, [slug]);

  useEffect(() => {
    if (
      !slug &&
      localStore.getItem('app-user') &&
      !localStore.getItem('app-foreman') &&
      !localStore.getItem('app-impersonate') &&
      !auth
    )
      localStore.removeItem('app-user');
  }, [isLogged]);
};
